import { HARDENING_CLUSTERS } from '@/lib/constants/hardening'
import { MDM_PROFILE_TYPE } from '@/lib/constants/mdm/policies'

// The CIS, Qalea library, Organization and history tabs of the Policies page
export const MDM_POLICY_LISTS = {
  COLUMNS: {
    POLICY: 'Política',
    CIS_REFERENCE: 'Referencia CIS',
    SCOPE: 'Alcance',
    HOSTS: 'Equipos',
    STATUS: 'Estado',
    TYPE: 'Tipo',
  },
  STATUS: {
    NOT_DEPLOYED: 'Sin desplegar',
    PENDING: 'Pendiente',
    DEPLOYED: 'Desplegada',
    FAILED: (count: number) => `${count} ${count === 1 ? 'fallido' : 'fallidos'}`,
  },
  HOSTS: (applied: number, total: number) => `${applied}/${total} equipos`,
  DEPLOY: 'Desplegar',
  SET_UP: 'Configurar',
  SEARCH_PLACEHOLDER: 'Buscar políticas...',
  TYPES: {
    [MDM_PROFILE_TYPE.CIS]: 'CIS Benchmark',
    [MDM_PROFILE_TYPE.PREDEFINED]: 'Biblioteca de Qalea',
    [MDM_PROFILE_TYPE.CUSTOM]: 'Organización',
  } as Record<string, string>,
  CIS: {
    TITLE: 'CIS Benchmark · Nivel 1',
    SUBTITLE: 'Recomendadas en todos los equipos para cumplir el CIS Benchmark',
    DEPLOYED: 'Desplegadas',
    DEPLOYED_COUNT: (deployed: number, total: number) => `${deployed} de ${total}`,
    DISK_ENCRYPTION_PLATFORMS: 'macOS y Windows',
    CHECKS: {
      [HARDENING_CLUSTERS.PASSWORD_SECURITY]: 'Contraseñas largas con caracteres variados',
      [HARDENING_CLUSTERS.DISK_ENCRYPTION]: 'FileVault y BitLocker, con la clave de recuperación guardada',
      [HARDENING_CLUSTERS.SCREEN_LOCK]: 'Bloqueo tras 5 minutos de inactividad',
      [HARDENING_CLUSTERS.PRIVILEGE_PROTECTION]: 'Los administradores confirman cada elevación',
      [HARDENING_CLUSTERS.HOST_FIREWALL]: 'Cortafuegos activo en todas las redes',
    } as Record<string, string>,
  },
  LIBRARY: {
    SUBTITLE: 'Políticas opcionales preparadas por Qalea',
    EMPTY: 'Aún no hay políticas de Qalea',
  },
  ORGANIZATION: {
    SEARCH_PLACEHOLDER: 'Buscar tus políticas...',
    SUBTITLE: 'Políticas creadas por tu equipo',
    ALL_HOSTS: 'Todos los equipos',
    EMPTY: 'Aún no hay políticas',
  },
  DRAWER: {
    DETAILS: 'Detalles',
    TYPE: 'Tipo',
    PLATFORM: 'Plataforma',
    CIS_REFERENCE: 'Referencia CIS',
    SCOPE: 'Alcance',
    LAST_DEPLOYED: 'Último despliegue',
    HOSTS: 'Equipos',
    HOSTS_TITLE: (count: number) => `Equipos (${count})`,
    NEVER: 'Nunca',
    NOT_DEPLOYED: 'Aún sin desplegar',
    CLOSE: 'Cerrar',
    REDEPLOY: 'Volver a desplegar',
  },
}
